import { createTheme } from '@mui/material/styles';

const theme = createTheme({palette: {
        primary: { main: '#4F7CC4' }
    },
    typography: {
        fontFamily: ['Roboto'],
    }
});

export default theme;